/**
 * @module timezone.transformer
 */
const timezoneFrom = (dbTimezone = {}) => {
  const transformedTimezone = {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type '{}'.
    id: dbTimezone.id,
    // @ts-expect-error TS(2339): Property 'timezone' does not exist on type '{}'.
    name: dbTimezone.timezone,
  };

  return transformedTimezone;
};

const timezonesFrom = (dbTimezoneList = []) => {
  // @ts-expect-error TS(2769): No overload matches this call.
  return dbTimezoneList.reduce((accumulator, tz) => {
    // Filter out any timezones that don't have a value.
    // @ts-expect-error TS(2339): Property 'timezone' does not exist on type 'never'... Remove this comment to see the full error message
    if (!tz.timezone) return accumulator;

    return [...accumulator, timezoneFrom(tz)];
  }, []);
};

export { timezoneFrom, timezonesFrom };
